<template>
  <div class="container">
    <el-page-header @back="goBack" content="待办事件" />

    <el-container class="body-container">
      <el-aside width="33%">    
        <user-info 
          :data="detail.user_info"
          :show-edit="showTagsEdit"
          @change-show="handleTagsShow" 
          @change-save="handleStatusUpdateSave"
          @change-tags-update="handleTagsUpdateSave"
          />

        <custom-info 
          :data="custom_info" 
          :show-edit="showCustomEdit" 
          @change-show="handleCustomShow" 
          @change-save="handleCustomSave"
          @change-update="handleCustomUpdateSave"/>

        <custom-member-info 
          :data="memberInfoList" 
          :show-del="showMemberEdit" 
          :submit-success="submitSuccess"
          @change-show="handleMemberShow" 
          @change-add="handleMemberAdd"
          @change-save="handleMemberSave"
          @change-update="handleMemberUpdateSave"
          @change-del="handleMemberDel"
          />

        <attachment-upload
          v-if="userId"
          :data="userId"
          @change-upload-save="handleCustomUploadSave"
          />
      </el-aside>

      <el-main>
        <custom-order-info
          :data="orderList" 
          :show-edit="showOrderEdit"
          @change-show="handleOrderShow" 
          @change-save="handleOrderSave" 
        />

        <pending-timeline 
          :data="detail.pending_event" 
          :show-edit="showEventEdit" 
          @change-show="handleEventShow" 
          @change-save="handleEventSave"/>
      </el-main>

      <el-aside width="33%">    
        <history-record 
          :data="detail.history" 
          :show-edit="showHistoryEdit" 
          @change-show="handleHistoryShow" 
          @change-save="handleHistorySave"/>
      </el-aside>
    </el-container>
  </div>
</template>

<script>
  import UserInfo from "../ui/customer-service/UserInfo"
  import PendingTimeline from "../ui/customer-service/PendingTimeline"
  import request from "@/api/request"
  import HistoryRecord from '../ui/customer-service/HistoryRecord.vue'
  import CustomInfo from '../ui/customer-service/CustomInfo.vue'
  import CustomMemberInfo from '../ui/customer-service/CustomMemberInfo.vue'
  import CustomOrderInfo from '../ui/customer-service/CustomOrderInfo.vue'
  import AttachmentUpload from '../ui/customer-service/AttachmentUpload.vue'

  export default {
    name: 'CustomerList',
    components: { UserInfo, PendingTimeline, HistoryRecord, CustomInfo, CustomMemberInfo, CustomOrderInfo, AttachmentUpload },
    data () {
      return {
        userId: null,
        memberId: null,
        detail: {},
        orderList: [],
        showCustomEdit: false,
        showMemberEdit: false,
        showEventEdit: false,
        showHistoryEdit: false,
        showTagsEdit: false,
        showOrderEdit: false,
        submitSuccess: false,
        memberInfoList: []
      }
    },
    computed: {
      custom_info: function () {
        let member = {}
        if (this.detail.family && this.detail.family.length > 0) {
          member =  this.detail.family.find(item => item.role === 'se')
        }
        return member
      },
      custom_member_info: function () {
        let ret = []
        if (this.detail.family && this.detail.family.length > 0) {
          ret = this.detail.family.filter(item => item.role !== 'se')
        }
        return ret
      },
    },
    created() {
      this.userId = parseInt(this.$route.params.user_id)
      this.getDetail()
      this.getOrderList()
    },
    methods: {
      getDetail() {
        request.cs.post('customer_detail', { user_id: this.userId}).then(resp => {
            this.detail = resp.data
            this.memberId = resp.data.user_info.customer_service.member_id
            if (this.detail.family && this.detail.family.length > 0) {
              this.memberInfoList = this.detail.family.filter(f => f.role !== 'se')
            }
          })
      },
      getOrderList() {
        request.cs.
          post('customer_order_list', 
            { 
              user_id: this.userId, 
              range: [0, 50], 
              sort: [
                {
                  field: 'id',
                  reverse: true
                }]
            })
          .then(resp => {
            this.orderList = resp.data.list
          })
      },
      handleCustomShow(value) {
        this.showCustomEdit = value
      },
      handleCustomSave(form) {
        request.cs
          .post('family_member_create', { user_id: this.userId, role: 'se', data: form})
          .then(() => {
            this.getDetail()
            this.showCustomEdit = false
            this.$message.success('保存成功')
          })
      },
      handleCustomUpdateSave(form) {
        request.cs
          .post('family_member_update', form)
          .then(() => {
            this.getDetail()
            this.showCustomEdit = false
            this.$message.success('保存成功')
          })
      },
      handleCustomUploadSave(form) {
        if (this.userId) {
          request.cs
            .post('file_create', Object.assign({ user_id: this.userId }, form))
            .then(() => {
              this.$message.success('上传成功')
            })
        }
      },
      handleMemberShow(value) {
        this.showMemberEdit = value
      },
      handleMemberAdd(value) {
        this.memberInfoList = value
      },
      handleMemberSave(role, form) {
        request.cs
          .post('family_member_create', { user_id: this.userId, role: role, data: form})
          .then(() => {
            this.getDetail()
            this.showMemberEdit = false
            this.submitSuccess = true
            this.$message.success('保存成功')
            this.$nextTick(() => {
              this.submitSuccess = false
            })
          })
          .catch(() => {
            this.submitSuccess = false
          })
      },
      handleMemberUpdateSave(form) {
        request.cs
          .post('family_member_update', form)
          .then(() => {
            this.getDetail()
            this.showCustomEdit = false
            this.submitSuccess = true
            this.$message.success('保存成功')
            this.$nextTick(() => {
              this.submitSuccess = false
            })
          })
          .catch(() => {
            this.submitSuccess = false
          })
      },
      handleMemberDel(value) {
        const p = []
        if (value ) {
          value.forEach(item => {
            if (item.id) {
              p.push(request.cs.post('family_member_status_update', { id: item.id, status: 900 }))
            }
          })
          Promise.all(p)
            .then(() => {                
              this.getDetail()
              this.showMemberEdit = false
              this.submitSuccess = true
              this.$nextTick(() => {
                this.submitSuccess = false
              })
            })
            .catch(() => {
              this.submitSuccess = false
            })
        }
      },
      handleEventShow(value) {
        this.showEventEdit = value
      },
      handleEventSave(form) {
        if (form.event_id) {
          request
            .cs
            .post('customer_event_status_update', form)
            .then(() => {
              this.getDetail()
              this.showEventEdit = false
              this.$message.success('保存成功')
          })
        } else {
          request.cs
            .post('customer_event_create', Object.assign({ user_id: this.userId, member_id: this.memberId }, form))
            .then(() => {
              request.cs.post('customer_remarks_create', { user_id: this.userId, member_id: this.memberId, content: form.content, source: 'e' })
              this.showEventEdit = false
              this.$message.success('保存成功')              
              this.getDetail()
            })
        }
      },
      handleHistoryShow(value) {
        this.showHistoryEdit = value
      },
      handleHistorySave(form) {
        request
          .cs
          .post('customer_remarks_create', Object.assign({ user_id: this.userId, source: 'm' }, form))
          .then(() => {
            this.getDetail()
            this.showHistoryEdit = false
            this.$message.success('保存成功')
        })
      },
      handleTagsShow(value) {
        this.showTagsEdit = value
      },
      handleStatusUpdateSave(form) {
        request
          .cs
          .post('customer_status_update', form)
          .then(() => {
            this.getDetail()
            this.$message.success('保存成功')
        })
      },
      handleOrderShow(row) {
        console.log(row)
      },
      handleOrderSave(row) {
        console.log(row)
      },
      handleTagsUpdateSave(form) {
        request
          .cs
          .post('customer_tag_update', form)
          .then(() => {
            this.getDetail()
            this.$message.success('保存成功')
            this.showTagsEdit = false
          })
      },
      goBack() {
        this.$router.push('/custom-service/customer')
      }
    }
  }
</script>

<style scoped>
  .body-container {
    margin: 20px 0;
  }
</style>
